"use strict";

Object.defineProperty(exports, Symbol.toStringTag, {
  value: "Module"
});
var e = require("../../chunks/Text.BdU2sTm7.cjs");
exports.Text = e.Text;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOltdLCJzb3VyY2VzQ29udGVudCI6W10sIm1hcHBpbmdzIjoiIiwiaWdub3JlTGlzdCI6W119